import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿RAZMEK es una aseguradora?",
    a: "No. Somos una firma independiente de asesoría patrimonial. Eso nos permite recomendar la solución que mejor se ajusta a tu caso entre múltiples instituciones, sin sesgos comerciales.",
  },
  {
    q: "¿Cuánto cuesta una asesoría?",
    a: "La primera consulta es sin costo y no compromete a contratar nada. Nuestro modelo se basa en comisiones que pagan las propias instituciones cuando contratas con ellas, no honorarios para ti.",
  },
  {
    q: "¿Atienden clientes fuera de la Ciudad de México?",
    a: "Sí. Operamos a nivel nacional con asesores en CDMX, Monterrey y Guadalajara, y atendemos remotamente a clientes en cualquier estado de la República.",
  },
  {
    q: "¿Manejan inversiones en dólares?",
    a: "Sí. Diseñamos estrategias en MXN y USD, incluyendo vehículos de ahorro indexados, fondos internacionales y planes con beneficios fiscales aplicables.",
  },
  {
    q: "¿Qué pasa después de la precalificación?",
    a: "Un asesor revisará tu información y te contactará en menos de 24h hábiles para agendar una sesión —presencial o remota— con un diagnóstico preliminar.",
  },
  {
    q: "¿Cómo cuidan mi información personal?",
    a: "Cumplimos con la LFPDPPP. Tus datos sólo son usados por nuestro equipo de asesores y nunca son compartidos con terceros sin tu consentimiento expreso.",
  },
];

const FAQ = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="eyebrow">Preguntas frecuentes</div>
            <h2 className="font-serif text-4xl lg:text-5xl mt-4 leading-[1.05] text-razmek-dark">
              Las dudas
              <br />
              <span className="italic text-razmek-blue">más comunes</span>.
            </h2>
            <p className="mt-6 font-sans text-base text-razmek-dark/60 max-w-sm">
              ¿No encuentras tu pregunta? Escríbenos por WhatsApp y un asesor te
              responderá en horas hábiles.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-razmek"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="font-serif text-xl lg:text-2xl text-razmek-dark hover:text-razmek-blue py-6 text-left"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-sans text-base leading-relaxed text-razmek-dark/70 pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
